import Anniversary from "../app/screens/customerCRMBusiness/anniversary";
import Birthday from "../app/screens/customerCRMBusiness/birthday";
import CustomerHome from "../app/screens/customerCRMBusiness/home";
import Instragram from "../app/screens/customerCRMBusiness/instagram";
import CustomerProducts from "../app/screens/customerCRMBusiness/products";
import CustomerProductview from "../app/screens/customerCRMBusiness/productview";
import CustomerProfile from "../app/screens/customerCRMBusiness/profile";
import Referral from "../app/screens/customerCRMBusiness/referral";
import Specialvoucher from "../app/screens/customerCRMBusiness/specialvoucher";
import CustomerThankyou from "../app/screens/customerCRMBusiness/thank-you";
import Uploaddesignvoucher from "../app/screens/customerCRMBusiness/uploaddesignvoucher";
import CustomerWishlist from "../app/screens/customerCRMBusiness/wishlist";
export const BusinessRouters = [
  {
    path: "/business-view/home",
    name: "home",
    icon: "flaticon-web",
    child: false,
    component: CustomerHome,
  },
  {
    path: "/business-view/products",
    name: "Products",
    icon: "flaticon-web",
    child: false,
    component: CustomerProducts,
  },
  {
    path: "/business-view/product-view",
    name: "Product View",
    icon: "flaticon-web",
    child: false,
    component: CustomerProductview,
  },
  {
    path: "/business-view/wish-list",
    name: "wish list",
    icon: "flaticon-web",
    child: false,
    component: CustomerWishlist,
  },
  {
    path: "/business-view/thank-you",
    name: "thank you",
    icon: "flaticon-web",
    child: false,
    component: CustomerThankyou,
  },
  {
    path: "/business-view/referral",
    name: "referral",
    icon: "flaticon-web",
    child: false,
    component: Referral,
  },
  {
    path: "/business-view/birthday",
    name: "birthday",
    icon: "flaticon-web",
    child: false,
    component: Birthday,
  },
  {
    path: "/business-view/anniversary",
    name: "Anniversary",
    icon: "flaticon-web",
    child: false,
    component: Anniversary,
  },
  {
    path: "/business-view/instagram",
    name: "Instragram",
    icon: "flaticon-web",
    child: false,
    component: Instragram,
  },
  {
    path: "/business-view/special-voucher",
    name: "special voucher",
    icon: "flaticon-web",
    child: false,
    component: Specialvoucher,
  },
  {
    path: "/business-view/upload-design",
    name: "upload design",
    icon: "flaticon-web",
    child: false,
    component: Uploaddesignvoucher,
  },
  {
    path: "/business-view/profile",
    name: "profile",
    icon: "flaticon-web",
    child: false,
    component: CustomerProfile,
  }
];
